import { DateTime } from "luxon";
import React, { useEffect, useState } from "react";
import generateLocalTimingObj from "./timeZoneConversionsMethods";

const CountDown = ({ timings, zone }) => {
  const [countDown, setCountDown] = useState("");
  const [countDownDate, setCountDownDate] = useState("");

  const generateCountDownTimer = (countDownDate) => {
    const now = new Date().getTime();
    const timeleft = countDownDate - now;

    const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

    setCountDown(
      days + "D : " + hours + "H : " + minutes + "M : " + seconds + "s"
    );
  };

  const countDownTimer = () => {
    const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
    const convertedTimeObj = generateLocalTimingObj(days, timings, zone);

    const todayDate = new Date();
    const todayDay = todayDate.toString().split(" ")[0].toLowerCase();

    // countdown
    let day = todayDay;
    let dayIndex = days.indexOf(todayDay);

    // if the timings of today is empty then to check how many days it goes ahead
    let count = 0;

    const generateCountDown = () => {
      // checking if the current day openings are empty or not
      // if it is empty then set next day for countdown and so on...
      if (convertedTimeObj[days[dayIndex]].length === 0) {
        dayIndex = dayIndex === 6 ? 0 : dayIndex + 1;
        day = days[dayIndex];
        count++;
      } else {
        // checking if today day is same as this date for countdown
        // if yes then check timing diff and generate countdown for particular time slots
        // if no then generate countdown for first time of that day
        if (todayDay === day) {
          // getting countdown for next time/day timings and sorting them
          const dayConvertedTimings = convertedTimeObj[days[dayIndex]];
          const sortedDayConvertedTimings = dayConvertedTimings.sort();

          const getCurrentHours = new Date().getHours();

          // counting diff of current hour with timings and store in positive and negative diff array
          let positiveDiff = [];
          let negativeDiff = [];
          sortedDayConvertedTimings.map((time, index) => {
            if (getCurrentHours - parseInt(time[0].slice(0, 2)) < 0) {
              negativeDiff.push({
                index,
                day,
                timeDiff: getCurrentHours - parseInt(time[0].slice(0, 2)),
              });
            } else {
              positiveDiff.push({
                index,
                day,
                timeDiff: getCurrentHours - parseInt(time[0].slice(0, 2)),
              });
            }
            // first we will check if the negatie diff is empty or not
            //if it is empty the we will generate next date first time stop countdown
            // else we will generate time slot wise countdown for current day
            // console.log(day, positiveDiff, negativeDiff);
            if (negativeDiff.length === 0) {
              let newCount = 0;

              // changing date variable to next date
              let newDayIndex = dayIndex === 6 ? 0 : dayIndex + 1;
              let newDay = days[newDayIndex];

              for (let i = newDayIndex; i < 7; i++) {
                if (convertedTimeObj[days[i]].length === 0) {
                  newDayIndex = newDayIndex === 6 ? 0 : newDayIndex + 1;
                  newDay = days[newDayIndex];
                  newCount = newCount + 1;
                } else {
                  break;
                }
              }

              if (convertedTimeObj[newDay].length === 0) {
                for (let i = 0; i < dayIndex; i++) {
                  if (convertedTimeObj[days[i]].length === 0) {
                    newDayIndex = newDayIndex === 6 ? 0 : newDayIndex + 1;
                    newDay = days[newDayIndex];
                    newCount = newCount + 1;
                  } else {
                    break;
                  }
                }
              }
              // console.log(day, count, todayDay);

              // getting next day first time slot starting time
              const nextDayDate = DateTime.now()
                .plus({ days: newCount + 1 })
                .toFormat("MMM dd, yyyy");

              console.log(nextDayDate);
              const getHours = convertedTimeObj[newDay]
                .sort()[0][0]
                .split("-")[0]
                .slice(0, 2);

              const getMins = convertedTimeObj[newDay]
                .sort()[0][0]
                .split("-")[0]
                .slice(
                  2,
                  convertedTimeObj[newDay].sort()[0][0].split("-")[0].length
                );

              const newDate = new Date(
                nextDayDate.trim() + ` ${getHours}:${getMins}:00`
              );
              generateCountDownTimer(newDate);

              const nextDayDateTime = DateTime.now()
                .plus({
                  days: newCount + 1,
                })
                .toFormat("MMM dd, yyyy");
              setCountDownDate(nextDayDateTime + ` ${getHours}:${getMins}`);
            } else {
              // getting first item from negative diff because our time is behindand that first iten will be our next time stop
              const nextHour = sortedDayConvertedTimings[
                negativeDiff[0].index
              ][0].slice(0, 2);
              const nextMin = sortedDayConvertedTimings[
                negativeDiff[0].index
              ][0].slice(
                2,
                sortedDayConvertedTimings[negativeDiff[0].index][0].length
              );
              const todayDateFormat = DateTime.now().toFormat("MMM dd, yyyy");
              console.log(todayDateFormat);
              const nextDateTime = new Date(
                todayDateFormat.trim() + ` ${nextHour}:${nextMin}:00`
              );
              generateCountDownTimer(nextDateTime);
              setCountDownDate(todayDateFormat + ` ${nextHour}:${nextMin}`);
            }
          });
        } else {
          // getting next day data
          const nextDayDate = DateTime.now()
            .plus({ days: count })
            .toFormat("MMM dd, yyyy");

          const getHours = convertedTimeObj[day]
            .sort()[0][0]
            .split("-")[0]
            .slice(0, 2);
          const getMins = convertedTimeObj[day]
            .sort()[0][0]
            .split("-")[0]
            .slice(2, convertedTimeObj[day].sort()[0][0].split("-")[0].length);

          const newDate = new Date(
            nextDayDate.trim() + ` ${getHours}:${getMins}:00`
          );
          generateCountDownTimer(newDate);

          // set next date time in state to show
          const nextDayDateTime = DateTime.now()
            .plus({
              days: count,
            })
            .toFormat("MMM dd, yyyy");
          setCountDownDate(nextDayDateTime + ` ${getHours}:${getMins}`);
        }
      }
    };

    setInterval(() => {
      generateCountDown(convertedTimeObj, days);
    }, 1000);
  };

  useEffect(() => {
    countDownTimer();
  }, []);
  return (
    <>
      &nbsp;{countDownDate}
      <p>{countDown} </p>
    </>
  );
};

export default CountDown;
